module.exports = __webpack_public_path__ + "media/images/solo-250-new-81107d124d3e53023f1dadc3578f6b2d.webp";